import * as fetch from 'isomorphic-fetch';
import * as moment from 'moment';

export function fetchEvents(startDate: string, endDate: string, courseTypes: Array<string>, eventTypes: Array<string>,
    format: Array<string>, instructor: string, location: string, showOnlyFreeEvents: boolean, offset: number, pageSize: number) {
    return fetch(`${window.location.origin}/api/calendar/GetEvents/`,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                startDate,
                endDate,
                courseTypes,
                eventTypes,
                format,
                instructor,
                location,
                showOnlyFreeEvents,
                offset,
                pageSize
            }),
            credentials: 'same-origin'
        }).then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            } else {
                return response.json();
            }
        })
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar-api-service.ts